
import React, { useState } from 'react';
import InfoIcon from '../Scaffolding/InfoIcon';
import IconTooltip from '../IconTooltip';

type ComponentWithHeadersProps = {
	X: string;
	Y: string;
	id: Array<any>;
	header: string;
	children?: React.ReactNode;
	tooltipText?: string;
}

function ComponentWithHeader({ X, Y, id, children, header, tooltipText }: ComponentWithHeadersProps): JSX.Element {
	const [showTooltip, setShowTooltip] = useState(false);
	const [pageX, setPageX] = useState(0);
	const [pageY, setPageY] = useState(0);

	return (
		<div className={`component-container ${X} ${Y}`} id={`${id[0]}-${id[1]}`}>
			<div className="component-title">
				<p className="component-title-text">{header}</p>
				{tooltipText && <InfoIcon setShowTooltip={setShowTooltip} setPageX={setPageX} setPageY={setPageY} />}
			</div>

			<div className="component">
				{React.Children.map(children, child => (child))}

			</div>
			{tooltipText && <IconTooltip id={`scorecard-${id[0]}-${id[1]}`} showTooltip={showTooltip} pageX={pageX} pageY={pageY} tooltipText={tooltipText} />}
		</div>
	);
}

export default ComponentWithHeader;
